export enum NAVIGATION_LINK {
  TABLES = '/tables',

  MANAGE = '/manage',
  MANAGE_DOWNLOAD_INVOICES = '/manage/download-invoices',

  LOGOUT = '/auth/logout'
}
